import React, { useEffect, useState } from 'react';
import { Modal, notify } from 'app/components';
import DateTime from '../../../event-create/components/step-1/dateTime';

const DateTimeModal = ({ show, setShow, onClose, formData, onChange }) => {
  const [data, setData] = useState(formData);

  useEffect(() => {
    setData(formData);
  }, [formData]);

  const handleSave = async () => {
    try {
      await onChange(data, 'Updated successfully', onClose);
      notify('success', 'Event rescheduled!');
      setShow(false);
    } catch (error) {
      notify('error', error?.message || 'Failed to reschedule event.');
    }
  };

  return (
    show && (
      <Modal size="medium" 
        className="modal-datetime" 
        primaryText="Save" 
        secondaryText="Cancel" 
        onClickPrimaryCta={handleSave} 
        onClickSecondaryCta={onClose}>

        <h1 className="heading-24">Edit date and time</h1>

        <DateTime formData={data} 
          setFormData={setData} />
          
      </Modal>
    )
  );
};

export default DateTimeModal;
